import { api, LightningElement } from "lwc";

export default class extends LightningElement {
  /** The image url for the tag */
  @api imageUrl: string = "";

  /** The title of the tag */
  @api title: string = "";
}
